module.exports = __webpack_public_path__ + "src/assets/img/knife.5b00f69f.svg";